import React, { useState } from "react";
import {
  HiOutlineCamera,
  HiOutlineUser,
  HiOutlineIdentification,
  HiOutlineEnvelope,
  HiOutlineBuildingOffice2,
  HiOutlineBriefcase,
  HiOutlineShieldCheck,
  HiOutlineXMark
} from "react-icons/hi2";

function Profile({ user, onClose, homePageLabel = "Dashboard" }) {
  const [avatar, setAvatar] = useState(null);

  const changeAvatar = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAvatar(URL.createObjectURL(file));
    }
  };

  const profileRows = [
    {
      icon: <HiOutlineUser />,
      label: "Username",
      value: user?.username || "-"
    },
    {
      icon: <HiOutlineUser />,
      label: "Name",
      value: user?.name || "-"
    },
    {
      icon: <HiOutlineIdentification />,
      label: "Employee ID",
      value: user?.emp_id || "-"
    },
    {
      icon: <HiOutlineEnvelope />,
      label: "Email",
      value: user?.email || "-"
    },
    {
      icon: <HiOutlineBuildingOffice2 />,
      label: "Department",
      value: user?.department || "-"
    },
    {
      icon: <HiOutlineBriefcase />,
      label: "Designation",
      value: user?.designation || "-"
    },
    {
      icon: <HiOutlineShieldCheck />,
      label: "Role",
      value: user?.role || "-"
    }
  ];

  return (
    <div style={overlay}>
      <div style={modal}>
        <button style={closeBtn} onClick={onClose}>
          <HiOutlineXMark />
        </button>

        <div style={header}>
          <div style={headerBadge}>Profile</div>
          <h2 style={title}>My Profile</h2>
          <p style={subtitle}>View your account details and personal information.</p>
        </div>

        <div style={content}>
          <div style={leftPanel}>
            <div style={avatarWrap}>
              <div style={avatarCircle}>
                {avatar ? (
                  <img src={avatar} alt="avatar" style={avatarImage} />
                ) : (
                  (user?.name || "U").charAt(0).toUpperCase()
                )}
              </div>

              <div style={nameBlock}>
                <h3 style={userName}>{user?.name || "User"}</h3>
                <p style={userSub}>{user?.designation || user?.role || "Employee"}</p>
              </div>

              <label style={uploadBtn}>
                <HiOutlineCamera style={{ fontSize: 16 }} />
                <span>Upload Photo</span>
                <input type="file" onChange={changeAvatar} hidden />
              </label>
            </div>
          </div>

          <div style={rightPanel}>
            {profileRows.map((item) => (
              <div key={item.label} style={infoCard}>
                <div style={infoLeft}>
                  <div style={infoIcon}>{item.icon}</div>
                  <div>
                    <div style={infoLabel}>{item.label}</div>
                    <div style={infoValue}>{item.value}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={footer}>
          <button style={backBtn} onClick={onClose}>
            Back to {homePageLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

const theme = {
  primary: "#0F766E",
  primaryDark: "#115E59",
  primaryLight: "#14B8A6",
  accent: "#2DD4BF",
  background: "#F8FAFC",
  surface: "#FFFFFF",
  surfaceSoft: "#ECFEFF",
  text: "#0F172A",
  textMuted: "#64748B",
  border: "#CCFBF1"
};

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(15, 23, 42, 0.35)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "24px",
  zIndex: 1200
};

const modal = {
  width: "100%",
  maxWidth: "920px",
  maxHeight: "90vh",
  overflowY: "auto",
  background: "linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%)",
  borderRadius: "24px",
  padding: "28px",
  position: "relative",
  boxShadow: "0 24px 60px rgba(15,23,42,0.18)",
  border: "1px solid #E6FFFB",
  fontFamily: "sans-serif"
};

const closeBtn = {
  position: "absolute",
  top: "18px",
  right: "18px",
  width: "38px",
  height: "38px",
  borderRadius: "12px",
  border: "none",
  background: theme.surfaceSoft,
  color: theme.primaryDark,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "20px"
};

const header = {
  marginBottom: "24px"
};

const headerBadge = {
  display: "inline-block",
  padding: "6px 12px",
  borderRadius: "999px",
  background: theme.surfaceSoft,
  color: theme.primaryDark,
  fontSize: "12px",
  fontWeight: 700,
  marginBottom: "12px"
};

const title = {
  margin: 0,
  fontSize: "28px",
  fontWeight: 800,
  color: theme.text
};

const subtitle = {
  margin: "8px 0 0 0",
  color: theme.textMuted,
  fontSize: "14px"
};

const content = {
  display: "grid",
  gridTemplateColumns: "280px 1fr",
  gap: "22px",
  alignItems: "start"
};

const leftPanel = {
  background: "linear-gradient(180deg, #ECFEFF 0%, #FFFFFF 100%)",
  border: `1px solid ${theme.border}`,
  borderRadius: "22px",
  padding: "22px"
};

const avatarWrap = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "14px"
};

const avatarCircle = {
  width: "118px",
  height: "118px",
  borderRadius: "50%",
  background: "linear-gradient(135deg, #0F766E 0%, #14B8A6 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  fontSize: "42px",
  fontWeight: 800,
  overflow: "hidden",
  boxShadow: "0 14px 30px rgba(15,118,110,0.20)"
};

const avatarImage = {
  width: "100%",
  height: "100%",
  objectFit: "cover"
};

const nameBlock = {
  textAlign: "center"
};

const userName = {
  margin: 0,
  fontSize: "20px",
  fontWeight: 800,
  color: theme.text
};

const userSub = {
  margin: "6px 0 0 0",
  color: theme.textMuted,
  fontSize: "13px"
};

const uploadBtn = {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  background: theme.surface,
  color: theme.primaryDark,
  border: `1px solid ${theme.border}`,
  padding: "10px 14px",
  borderRadius: "12px",
  cursor: "pointer",
  fontWeight: 700,
  fontSize: "13px"
};

const rightPanel = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "14px"
};

const infoCard = {
  background: theme.surface,
  border: "1px solid #E2E8F0",
  borderRadius: "18px",
  padding: "14px 16px",
  boxShadow: "0 8px 20px rgba(15,23,42,0.05)"
};

const infoLeft = {
  display: "flex",
  alignItems: "flex-start",
  gap: "12px"
};

const infoIcon = {
  width: "36px",
  height: "36px",
  borderRadius: "12px",
  background: theme.surfaceSoft,
  color: theme.primary,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "18px",
  flexShrink: 0
};

const infoLabel = {
  fontSize: "12px",
  color: theme.textMuted,
  fontWeight: 700,
  marginBottom: "4px"
};

const infoValue = {
  fontSize: "14px",
  color: theme.text,
  fontWeight: 700,
  wordBreak: "break-word"
};

const footer = {
  marginTop: "24px",
  display: "flex",
  justifyContent: "flex-end"
};

const backBtn = {
  border: "none",
  background: "linear-gradient(135deg, #0F766E 0%, #14B8A6 100%)",
  color: "#fff",
  padding: "12px 18px",
  borderRadius: "14px",
  cursor: "pointer",
  fontWeight: 700,
  fontSize: "14px",
  boxShadow: "0 10px 24px rgba(15,118,110,0.18)"
};

export default Profile;